module.exports = __webpack_public_path__ + "img/oneclose_logo.fc5b2891.png";